/** Where the portal starts.
 *
 * The session provider sits outside the router because the account is not a
 * property of the current address: it is read once, and the router then
 * decides what to show given it. The order also means that signing out — a
 * full navigation, not a state change — happens without a route transition
 * racing it.
 *
 * The stylesheet is imported here and nowhere else, so `tokens.css` is the
 * document's one source of colour and every screen inherits it whether or not
 * it remembered to ask.
 */

import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { App } from '@/App';
import { SessionProvider } from '@/lib/session';
import '@/styles/tokens.css';

const container = document.getElementById('root');
if (!container) {
  throw new Error('index.html is missing its #root element');
}

createRoot(container).render(
  <StrictMode>
    <SessionProvider>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </SessionProvider>
  </StrictMode>,
);
